/**
 * usePublicPlans — loads the public pricing plans for the homepage.
 * One unauthenticated call to /public/plans; the Pricing section renders from it.
 */
import { useEffect, useState } from 'react';
import { getPublicPlans, PublicPlan } from '@/services/public.api';

export function usePublicPlans(): { plans: PublicPlan[]; loading: boolean; error: string | null } {
  const [plans, setPlans] = useState<PublicPlan[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    getPublicPlans()
      .then((p) => {
        if (alive) setPlans(p);
      })
      .catch((e: any) => {
        if (alive) setError(e?.message ?? 'Failed to load plans');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return { plans, loading, error };
}
